import React from 'react';

import cn from 'classnames';

import { Link as ILink, LinkView } from '@rcdev/api-bff-parking';
import { Button } from '@runity/ui-button';
import { Link as UILink } from '@runity/ui-link';
import { Text } from '@runity/ui-text';

import styles from './link.pcss';

type TSize = 's' | 'xs' | 'm' | 'l';

interface ILinkProps extends ILink {
  size?: TSize;
}

const getButtonStyles = (view: LinkView) => {
  switch (view) {
    case LinkView.ButtonOutlined:
      return 'secondary';
    case LinkView.ButtonFilled:
    default:
      return 'primary';
  }
};

export const Link = ({ size = 'm', ...link }: ILinkProps) => {
  const { view, title, url, target } = link;

  if (view === LinkView.Default) {
    return (
      <UILink href={url} target={target} className={styles.defaultLink}>
        <Text preset="textLarge">{title}</Text>
      </UILink>
    );
  }

  return (
    <Button color={getButtonStyles(view)} size={size}>
      <UILink
        className={cn(styles.linkInBtn, styles[getButtonStyles(view)])}
        href={url}
        target={target}
      >
        {title}
      </UILink>
    </Button>
  );
};
